// extracted by mini-css-extract-plugin
module.exports = {"feature":"cg_m2","feature_negative":"cg_m3","feature__icon":"cg_m4","feature__description":"cg_m5"};